module.exports = __webpack_public_path__ + "images/external_images/img/demo/real-estate/property-2.jpg";